import { STORAGE_CONSTANTS } from "../../../../../constants/storageConstants";
import { setLocalStorageItems, getLocalStorageItems } from "../../../../helpers/localStorage/localStorage";

export const setSelectedAccountInLocalStorage = (data) => {
    return setLocalStorageItems(STORAGE_CONSTANTS.SELECTED_ACCOUNT, data);
}

export const getSelectedAccountInLocalStorage = () => {
   return getLocalStorageItems(STORAGE_CONSTANTS.SELECTED_ACCOUNT);
}